import React from 'react';
import UtilityCard from './UtilityCard';
import useHideOnSite from '../../../hooks/useLanguageFilter';

const Card = ({
  blok,
  destination,
  hotel,
  price,
  priceType,
  season,
  hasHorizontalScroll,
  hasSiblings,
  parentWidth,
}) => {
  return useHideOnSite(blok.hide_on_site) ? null : (
    <UtilityCard
      blok={blok}
      destination={destination}
      hotel={hotel}
      price={price}
      priceType={priceType}
      season={season}
      hasHorizontalScroll={hasHorizontalScroll}
      hasSiblings={hasSiblings}
      parentWidth={parentWidth}
    />
  );
};

export default Card;
